import PropTypes from 'prop-types';
import React from 'react';
import Link from '../../components/Shared/Link';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import CTASimple from '../../components/CTASimple/CTASimple';
import theme from '../../styles/theme';
import ButtonLink from '../../components/Shared/ButtonLink';
import Featurette from '../../components/Featurette/Featurette';
import Documents from '../../components/Documents/Documents';
import Posts from '../../components/Posts/Posts';
import Error from '../../components/Error/Error';
import ReactMarkdown from 'react-markdown';
import Picture from '../../components/Shared/Picture';
//TODO: Remove happy houses
//import PiggyBankImage from '../../../public/images/piggy-bank.png';
import InsuranceClaimImage from '../../../public/images/insurance-claim-image.png';
import InsuranceClaimIcon from '../../components/Shared/Icons/InsuranceClaim';
import EscrowIcon from '../../components/Shared/Icons/EscrowHome';
import { getPageContent } from '../../services/dpc';
import { getEmbeddedContent } from '../../services/embeddedContent';
import useGTM from '../../hooks/useGTM';
import Styles from './HomeOwning.styled';
import CTACard from '../../components/CTACard/CTACard';
import Heading from '../../components/Heading/Heading';
import HeroVideo from '../../components/HeroVideo/HeroVideo';
import EmailSignup from '../../components/Shared/EmailSignup';
import { useInView } from 'react-intersection-observer';
import createGTMClass from '../../util/createGTMClass';
import CTACardv2 from '../../components/CTACardv2/CTACardv2';

function HomeOwning({
  data: {
    contentCTAs,
    contentVideos,
    faqPod,
    heroCta,
    heroMedia,
    mobileHeroMedia,
    metaDescription,
    preFooterCta,
    tipsAndToolsPod,
    titleTag,
    customerReviewPod,
    pageTitle,
    webForm,
  } = {},
  blogData,
  error,
  isLoading,
}) {
  if (error) {
    console.error(error);
    return (
      <Layout>
        <Error />
      </Layout>
    );
  }
  const [triggerGTMEvent] = useGTM();
  const posts =
    tipsAndToolsPod &&
    tipsAndToolsPod.map(
      ({ title, contentTag, category, slug, featuredMedia }) => ({
        title,
        category,
        contentTag,
        thumbnail: `${featuredMedia?.media?.fields?.file?.url}?w=300`,
        slug,
      })
    );

  const resourcePosts =
    blogData
      ?.map(
        ({
          embeddedContentHeader: title,
          thumbnail,
          videoSource,
          embeddedcontent,
        }) => ({
          title,
          contentTag: 'Video',
          thumbnail: `${thumbnail?.fields?.file?.url}?w=300`,
          mediaType: 'Video',
          video: {
            source: videoSource,
            content: embeddedcontent,
          },
        })
      )
      ?.slice(0, 12) || [];

  const onEmailSubmit = () => {
    triggerGTMEvent({
      name: 'vmf.cta_click',
      location: 'Homeowner LP',
      category: 'loan_education',
      action: 'form',
      label: 'email_sign_up_submit',
    })();
  };

  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  return (
    <Layout isLoading={isLoading}>
      <SEO title={titleTag} description={metaDescription} />
      <Styles>
        {/* Title Heading */}
        <Heading>
          {pageTitle?.toLowerCase()?.trim() ===
          'our tips for being a successful homeowner.' ? (
            <>
              <h1 className='type-h1 title-heading title-heading--mobile'>
                Our tips for being a
                <br />
                successful homeowner.
              </h1>
              <h1 className='type-h1 title-heading title-heading--desktop'>
                Our tips for being a successful homeowner.
              </h1>
            </>
          ) : (
            <h1 className='type-h1 title-heading'>{pageTitle}</h1>
          )}
        </Heading>

        {/* Hero */}
        <HeroVideo
          configuration='homeOwning'
          title={heroCta?.ctaHeader || "Vanderbilt Homeowner's Guide"}
          cta='null'
          link={{
            to:
              heroCta?.firstCTAButtonUrl ||
              '//assets.ctfassets.net/y64yks2od8ab/4Zqi6jbsI1DbIo4k6a4Hkg/7681e21d56f9fbda08a317f0a4a5ec9c/VMF_Homeowner-s_Guide.pdf',
            title: heroCta?.firstCTAButtonText || 'View Guide',
            isExternal: true,
            newTab: true,
            contentfulColors: heroCta?.buttonAndTextColors,
            onClick: triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Homeowner LP',
              category: 'homeowner_education',
              action: 'button',
              label: 'homeowner_guide_cta',
            }),
          }}
          image={{
            src: heroMedia?.[0]?.media?.fields?.file?.url,
            alt: heroMedia?.[0]?.altText,
          }}
        >
          <p className='type-p'>{heroCta?.ctaIntro}</p>
        </HeroVideo>

        {/* Home Care Videos */}

        <Posts posts={resourcePosts} title='Home Care Video Tips' />

        {/* <CTAExpress
          backgroundImagePath={contentCTAs?.[0]?.ctaImage?.fields?.file?.url}
          mobileBackgroundImagePath={contentCTAs?.[0]?.ctaMobileImage?.fields?.file?.url}
          subHeader={contentCTAs?.[0]?.ctaSubHeader}
          intro1={contentCTAs?.[0]?.ctaIntro.slice(0, 21)}
          intro2={contentCTAs?.[0]?.ctaIntro.slice(21, 73)}
          intro3={contentCTAs?.[0]?.ctaIntro.slice(73)}
          link={{
            title: contentCTAs?.[0]?.firstCTAButtonText || 'Create account',
            to:
              contentCTAs?.[0]?.firstCTAButtonUrl ||
              'https://www.vmf.com/portal/onboarding',
            onClick: triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Homeowner LP',
              category: 'create_account',
              action: 'button',
              label: 'express_lending_create_account'
            })
          }}
          secondaryLink={{
            title: contentCTAs?.[0]?.secondCTAButtonText || 'Sign in',
            to:
              contentCTAs?.[0]?.secondCTAButtonUrl ||
              'https://www.vmf.com/portal/login',
              onClick: triggerGTMEvent({
                name: 'vmf.cta_click',
                location: 'Homeowner LP',
                category: 'account_sign_in',
                action: 'button',
                label: 'express_lending_sign_in',
                }),
          }}
        /> */}

        <section className='paragraph-section'>
          <Featurette
            dropShadow={false}
            reverseOnMobile={true}
            primary={
              <div className='loan-section'>
                <EscrowIcon />
                <h3 className='type-h3 section-title'>Escrow</h3>
                <p className='type-p'>
                  Escrow is a separate amount collected along with your
                  scheduled mortgage payment. The funds are collected to pay
                  your future homeowners insurance premium and/or taxes.
                </p>
                <Link
                  to='/escrow/'
                  onClick={triggerGTMEvent({
                    name: 'vmf.cta_click',
                    location: 'Homeowner LP',
                    category: 'loan_education',
                    action: 'text',
                    label: 'escrow_text_cta',
                  })}
                  isExternal={true}
                >
                  Learn More
                </Link>
              </div>
            }
            secondary={
              <Picture
                src='https://images.ctfassets.net/y64yks2od8ab/1cN8n4PmGe4oKooyh12Xvh/2cb7a387a0cb09b3fc004fcefd72ec8b/energy-efficient.jpg?w=520'
                alt='Shop Preowned Vanderbilt Homes'
              />
            }
            center={true}
          />
        </section>

        {/* Calculator */}
        <CTASimple
          title={contentCTAs?.[1]?.ctaHeader}
          className='mortgage-calc'
          link={{
            title: contentCTAs?.[1]?.firstCTAButtonText || 'Estimate Payment',
            to:
              contentCTAs?.[1]?.firstCTAButtonUrl ||
              '/calculators/mortgage-calculator/',
            size: 'large',
            onClick: triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Homeowner LP',
              category: 'loan_education',
              action: 'button',
              label: 'early_payoff_calculator_cta',
            }),
          }}
          condensed={true}
          borders={true}
        >
          <p className='type-p'>{contentCTAs?.[1]?.ctaIntro}</p>
        </CTASimple>

        {/* Single Paragraph Section */}
        <section className='paragraph-section'>
          <Featurette
            primary={
              <Picture
                src={InsuranceClaimImage}
                alt='Shop Preowned Vanderbilt Homes'
              />
            }
            secondary={
              <div className='insurance-claim-section'>
                <InsuranceClaimIcon />
                <h3 className='type-h3 section-title'>
                  Filing an Insurance Claim
                </h3>
                <p className='type-p'>
                  Need to file an insurance claim with your insurer? Vanderbilt
                  Mortgage and Finance is here to help you with every step.
                  Learn what to expect if you need to file an insurance claim.
                </p>
                <Link
                  to='https://www.vmf.com/resources/faqs/insurance/'
                  isExternal={true}
                  onClick={triggerGTMEvent({
                    name: 'vmf.cta_click',
                    location: 'Homeowner LP',
                    category: 'homeowner_education',
                    action: 'text',
                    label: 'insurance_claim_text_cta',
                  })}
                >
                  Learn More
                </Link>
              </div>
            }
            center={true}
          />
        </section>

        {/* Document Section */}
        <section className='doc-section'>
          <Documents>
            <h2 className='type-h2'>Documents & Forms</h2>
            <p>
              Login to your account to print/view your 1098 Tax Form or Payoff
              Quote free of charge. You can also request additional documents.
              Learn more if you want to see all our request options.
            </p>
            <section className='links'>
              <ButtonLink
                to={'/resources/documents-forms'}
                appearance='dark'
                className={createGTMClass('view_all_docs', 'cta', 'button')}
                onClick={triggerGTMEvent({
                  name: 'vmf.cta_click',
                  location: 'Homeowner LP',
                  category: 'homeowner_education',
                  action: 'button',
                  label: 'documents_forms_cta_button',
                })}
              >
                View all documents
              </ButtonLink>
            </section>
          </Documents>
        </section>

        {/* Tools and Tips */}
        <Posts
          title='Tips & Tools'
          className='home-owning-posts'
          link={{
            title: 'View all',
            to: '/resources/blog/',
            onClick: triggerGTMEvent({
              name: 'vmf.cta_click',
              location: 'Homeowner LP',
              category: 'homeowner_education',
              action: 'text',
              label: 'tips_tools_text_cta',
            }),
          }}
          posts={posts}
          configuration='homeBuying'
        />

        {/* Email Signup */}
        <CTACard
          animationThreshold={0.2}
          backgroundBottom={theme.colors.white}
          className='email-subscribe'
          flat={true}
          form={
            <EmailSignup
              buttonLabel={webForm?.[0]?.firstFormButtonText}
              originCampaign={webForm?.[0]?.originCampaign}
              originWebApp={webForm?.[0]?.originWebApp}
              originWebFormCategory={webForm?.[0]?.originWebFormCategory}
              originWebFormType={webForm?.[0]?.originWebFormType}
              originWebPageType={webForm?.[0]?.originWebPageType}
              dataExtension={webForm?.[0]?.dataExtension}
              onEmailSubmit={onEmailSubmit}
            />
          }
          disclaimer={
            <ReactMarkdown
              source={webForm?.[0]?.disclaimer}
              renderers={{
                paragraph: ({ children }) => (
                  <p className='type-caption bold color-grey1'>{children}</p>
                ),
              }}
            />
          }
          divider={false}
        >
          <p className='type-label-large bold'>{webForm?.[0]?.formIntro}</p>
          <h3 className='type-h1'>{webForm?.[0]?.formHeader}</h3>
        </CTACard>

        {/* Contact Us Section */}
        <CTACardv2
          preHeaderContent={'Have Questions?'}
          headerContent={`We're Here to Help`}
          buttonText={'Contact Us'}
          buttonUrl={'/contact-us/'}
          gtmClassName={'contact'}
          ctaIntro={
            <>
              <p>
                Existing customers{' '}
                <a href='tel:1-800-970-7250'>1-800-970-7250</a>
              </p>
              <p>
                New customers <a href='tel:1-866-701-0467'>1-866-701-0467</a>
              </p>
            </>
          }
        />
      </Styles>
    </Layout>
  );
}

HomeOwning.getInitialProps = async ({}) => {
  try {
    const data = await getPageContent('/home-owning/');
    const blogData = await getEmbeddedContent('Home Care Video Tips');

    if (data.status !== 200) {
      throw data.statusText;
    }

    if (blogData.status !== 200) {
      throw blogData.statusText;
    }

    return {
      data: data.data.result,
      blogData: blogData.data.result,
    };
  } catch (error) {
    return {
      error,
    };
  }
};

HomeOwning.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default HomeOwning;
